import type { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import type { AppProps } from './App';

const getInitialState: GetInitialStateInner<AppProps> = () => {
  return {
    // @ts-expect-error This is a global variable that is set by the server.
    LiveLandingV2: window.__INITIAL_STATE__.LiveLandingV2,
  };
};

export default getInitialState;
